<div class="flex flex-col h-full bg-white rounded-2xl">
  <!-- Comments List -->
  <div #commentsContainer class="flex-1 overflow-y-auto p-4">
    @if (comments().length > 0) {
      @for (comment of comments(); track comment.id) {
        <div class="mb-2">
          <app-comment-bubble 
            [comment]="comment" 
            [isCurrentUser]="isCurrentUserComment(comment)"
          />
        </div>
      }
    } @else {
      <div class="text-center text-gray-500 py-8">
        No comments yet. Be the first to comment!
      </div>
    }
  </div>

  <!-- Comment Input Section -->
  <div class="border-t border-gray-200 p-4">
    <div class="flex gap-3">
      <textarea
        [(ngModel)]="newComment"
        placeholder="Write a comment..."
        rows="3"
        class="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none"
        [disabled]="isSubmitting()"
        (keydown.control.enter)="sendComment()"
      ></textarea>
      <button
        (click)="sendComment()"
        [disabled]="!newComment().trim() || isSubmitting()"
        class="px-6 py-2 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors self-end"
      >
        @if (isSubmitting()) {
          Sending...
        } @else {
          Send
        }
      </button>
    </div>
  </div>
</div>
